import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Modal } from "rsuite";

import { dictionaryCRUD } from "../../../actions/dictionary";
import { selector } from "../../../api";
import { Divider, Input } from "antd";
import { useNotification } from "../../../utils/notificationProvider";

const dictionarySchema = Yup.object().shape({
  dictionary_name: Yup.string().required("This field is required"),
});

const initialValues = {
  dictionary_code: "",
  dictionary_name: "",
};

export const DictionaryAdd = (props) => {
  const { open, setOpen, index, setIndex } = props;
  const user = selector.User();
  const [loading, setLoading] = useState(false);
  const openNotification = useNotification()

  const formik = useFormik({
    initialValues,
    validationSchema: dictionarySchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { dictionary_code, dictionary_name } = values;
      const recorded_by = user.id;
      const data = {
        dictionary_code,
        dictionary_name,
        recorded_by,
      };
      setLoading(true);
      setTimeout(() => {
        dictionaryCRUD
          .addDictionary([data])
          .then(() => {
            openNotification(
              "success",
              "Success",
              <>
                🎉 Congratulations...!
                <br />
                Your data has been successfully saved...!
              </>
            );
            setIndex(index + 1);
            resetForm();
            setLoading(false);
            setSubmitting(false);
            setOpen(false);
          })
          .catch((error) => {
            setLoading(false);
            setSubmitting(false);
            openNotification(
              "error",
              "Error",
              <>
                Oops...!
                <br />
                Something went wrong. Please try again.
              </>
            );
          });
      }, 2000);
    },
  });

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} size="md">
        <Modal.Header>
          <Modal.Title>New Dictionary</Modal.Title>
        </Modal.Header>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="text-body mb-2">Dictionary Code</label>
                    <Input
                      variant="filled"
                      size="large"
                      placeholder="Dictionary code"
                      {...formik.getFieldProps("dictionary_code")}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="text-body mb-2">
                      Dictionary Name{" "}
                      <span className="text-danger">&nbsp;*</span>
                    </label>
                    <Input
                      variant="filled"
                      size="large"
                      placeholder="Dictionary name"
                      {...formik.getFieldProps("dictionary_name")}
                      status={
                        formik.touched.dictionary_name &&
                        formik.errors.dictionary_name &&
                        "error"
                      }
                    />
                    {formik.touched.dictionary_name &&
                      formik.errors.dictionary_name && (
                        <div
                          className="fw-light mt-1"
                          style={{ fontSize: "12px" }}
                        >
                          <span role="alert" className="text-danger">
                            {formik.errors.dictionary_name}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Divider style={{ marginTop: -10 }} />
          <Modal.Footer>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 d-flex justify-content-start">
                  <span className="fs-18 text-danger"> * &nbsp;</span> Required
                  field
                </div>
                <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button
                    onClick={handleClose}
                    type="button"
                    className="btn btn-soft-danger me-3"
                  >
                    <i class="ri-close-circle-line align-middle fs-16 me-2"></i>{" "}
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-soft-success"
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    {!loading && (
                      <span className="indicator-label">
                        <i class="ri-check-double-line align-middle fs-16 me-2"></i>{" "}
                        Save
                      </span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
